import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentReducer } from '../reducers';

export const selectPaymentFeature = createFeatureSelector<PaymentReducer.PaymentState>(PaymentReducer.featureName);

export const selectPayment = createSelector(selectPaymentFeature, (state: PaymentReducer.PaymentState) => state.item);
